import { Writable } from 'stream'

const LATEST_VAL_ONLY = true

class AlertGraphType extends Writable {
  constructor() {
    super({ objectMode: true })
    this.ignoreDataLoaded = true
    this.viewOptions = {}
    this.latestValue = null
    this._data = []
  }

  _write = (data, enc, next) => {
    if (Array.isArray(data)) {
      if (LATEST_VAL_ONLY) {
        this._data = data.filter(o => o.killChainStage !== "Methodology")
      }
      else {
        this._data.unshift(data) // Zero index is latest
        // TODO align objects to time buckets?
        this._data.length = 60 // Cap at 60 buckets FIXME config, or make this a real TimeSeriesRingBuffer
      }
    }
    next()
  }

  destroy = () => {
    if (this.destroyed) { return }
    this.destroyed = true
  }

  setViewOptions = (viewOptions) => {
    this.viewOptions = viewOptions
  }

  getGraphData = () => this._data
}

export default AlertGraphType